module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ce-Db-Ef-Fb-Gc.d37b52ea.png";